<template>
    <div class="form-group">
        <label v-if="label" :for="name">{{label}}</label>
        <file-pond :id="name" :name="name" :ref="name" :label-idle="Lang.get('messages.upload-label')"
            :allow-multiple="multiple" :accepted-file-types="filesTypes" :server="server" :files="myFiles"
            :disabled="disabled" />
        <small class="form-text text-danger" v-if="errors[name]" v-text="errors[name][0]" />
    </div>
</template>

<script>
    import vueFilePond from 'vue-filepond';
    import ApiService from '@services/api.service';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

    export default {
        props: {
            label: {
                type: String
            },

            type: {
                type: String,
                default: 'text'
            },

            name: {
                type: String,
                required: true
            },

            model: {
                type: [Object, Array],
                required: true
            },

            errors: {
                type: [Object, Array],
                required: true
            },

            uploadApi: {
                type: String,
                required: true
            },

            filesTypes: {
                type: [String, Array]
            },

            disabled: {
                type: Boolean
            },

            multiple: {
                type: Boolean
            }
        },

        watch: {
            model(newV, oldV) {
                if (newV[this.name] == null) {
                    this.myFiles = [];
                }
            }
        },

        components: {
            FilePond: vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType)
        },

        data() {
            return {
                myFiles: [],
                server: {
                    process: (fieldName, file, metadata, load, error, progress, abort) => {
                        // fieldName is the name of the input field
                        // file is the actual file object to send
                        const formData = new FormData();
                        formData.append(fieldName, file, file.name);

                        // Send axios post request
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        const axiosConfig = {
                            cancelToken: source.token,
                            onUploadProgress: function (e) {
                                progress(e.lengthComputable, e.loaded, e.total);
                            }
                        }
                        ApiService.post(this.uploadApi, formData, axiosConfig)
                            .then((response) => {
                                if (response.status >= 200 && response.status < 300) {
                                    // the load method accepts either a string (id) or an object
                                    load(response.data.id);
                                    this.onCompleted(response.data.id);
                                } else {
                                    // Can call the error method if something is wrong, should exit after
                                    error('oh no');
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            });

                        // Should expose an abort method so the request can be cancelled
                        return {
                            abort: () => {
                                // This function is entered if the user has tapped the cancel button
                                source.cancel('Operation canceled by the user.');

                                // Let FilePond know the request has been cancelled
                                abort();
                            }
                        };

                    }
                }
            }
        },

        methods: {
            onCompleted(data) {
                if (this.model[this.name] == null) {
                    this.model[this.name] = [];
                }
                this.model[this.name].push(data);
                // this.$set(this.model, this.name, [data]);      
                this.$emit('completed', data);
            }
        }
    }

</script>

<style>
</style>
